import { Button, Progress, Table } from "antd";

export const columns = [
  {
    title: "Industries",
    dataIndex: "name",
    render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
  },
  {
    title: "Market Widget",
    dataIndex: "overview.market_weight",
    render: (text, row) => {
      let markerWeight = row?.overview?.market_weight * 100;
      markerWeight =
        markerWeight && markerWeight !== 0 ? markerWeight.toFixed(2) : 0;
      return (
        <>
          <Progress
            percent={markerWeight}
            format={(percent) => (
              <span style={{ color: "black" }}>{percent}%</span>
            )}
            percentPosition={{
              type: "outer",
              align: "end",
            }}
            size={[120, 15]}
            strokeColor="#7eabd6"
          />
        </>
      );
    },
  },
  {
    title: "Industries",
    dataIndex: "industries_count",
    render: (text, row) => {
      return row?.overview?.industries_count;
    },
  },
  {
    title: "Companies",
    dataIndex: "companies_count",
    render: (text, row) => {
      return row?.overview?.companies_count;
    },
  },
];

export const dataSource = [
  {
    key: "all_industries",
    industry: "All Industries",
    marketWidget: 100,
    trends: "+25.5%",
  },
  {
    key: "2",
    industry: "Semiconductors",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+12.3%",
  },
  {
    key: "3",
    industry: "Software - Infrastructure",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+8.7%",
  },
  {
    key: "4",
    industry: "Computer Electronics",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+15.2%",
  },
  {
    key: "5",
    industry: "Software - Application",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+10.4%",
  },
  {
    key: "6",
    industry: "Information Technology",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+9.8%",
  },
  {
    key: "7",
    industry: "Communication Equipment",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+18.6%",
  },
  {
    key: "8",
    industry: "Computer Hardware",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+7.3%",
  },
  {
    key: "9",
    industry: "Electronic Components",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+11.1%",
  },
  {
    key: "10",
    industry: "Scientific Institute",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+13.5%",
  },
  {
    key: "11",
    industry: "Solar",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+6.9%",
  },
  {
    key: "12",
    industry: "Technical Institute",
    marketWidget: Math.floor(Math.random() * 100),
    trends: "+16.9%",
  },
];
// Tables work
export const topCompaniesColumns = [
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Market Weight",
    dataIndex: "marketWeight",
    key: "marketWeight",
    render: (value) => `${(value * 100).toFixed(2)}%`,
  },
  {
    title: "Rating",
    dataIndex: "rating",
    key: "rating",
  },
];

export const topGrowthCompaniesColumns = [
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "YTD Return",
    dataIndex: "ytdReturn",
    key: "ytdReturn",
    render: (value) => `${(value * 100).toFixed(2)}%`,
  },
  {
    title: "Growth Estimate",
    dataIndex: "growthEstimate",
    key: "growthEstimate",
    render: (value) => (value !== null ? `${(value * 100).toFixed(2)}%` : "N/A"),
  },
];

export const topPerformingCompaniesColumns = [
  {
    title: "Symbol",
    dataIndex: "symbol",
    key: "symbol",
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "YTD Return",
    dataIndex: "ytdReturn",
    key: "ytdReturn",
    render: (value) =>{
      if(value){
       return `${(value * 100).toFixed(2)}%`
      }
      else return 0;
    } 
  },
  {
    title: "Last Price",
    dataIndex: "lastPrice",
    key: "lastPrice",
    render: (value) => {
      if(value){
       return `$${value.toFixed(2)}`
      }
      else return 0;
    }    
  },
  {
    title: "Target Price",
    dataIndex: "targetPrice",
    key: "targetPrice",
    render: (value) => 
     {
      if(value){
      return `$${value.toFixed(2)}`
     }
     else return 0;
   }   
  }
  
];
